import { render, staticRenderFns } from "./KeysByPrex.vue?vue&type=template&id=62c89b6e&scoped=true&"
import script from "./KeysByPrex.vue?vue&type=script&lang=js&"
export * from "./KeysByPrex.vue?vue&type=script&lang=js&"
import style0 from "./KeysByPrex.vue?vue&type=style&index=0&id=62c89b6e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62c89b6e",
  null
  
)

export default component.exports